import fundingSvc from '@efex-services/funds/fundingSvc';
import { useEffect } from 'react';
import { useApiCall } from 'use-api-call';
import {
  UseDownloadInstructionsProps,
  UseDownloadInstructionsResponse,
} from '../types';

const useDownloadInstructions = ({
  enterpriseId,
  currency,
  walletId,
}: UseDownloadInstructionsProps): UseDownloadInstructionsResponse => {
  const {
    data: dataBuff,
    loading,
    invoke: invokeDownload,
  } = useApiCall(() =>
    fundingSvc.addFundDownload({
      enterpriseId,
      currency,
      walletId,
    })
  );

  const handleDownload = async () => {
    await invokeDownload();
  };

  useEffect(() => {
    if (dataBuff) {
      const data = Uint8Array.from(atob(dataBuff), (c) => c.charCodeAt(0));
      const blob = new Blob([data], { type: 'octet/stream' });
      const link = document.createElement('a');
      link.style.visibility = 'hidden';
      link.href = window.URL.createObjectURL(blob);
      link.download = 'account-info.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [dataBuff]);

  return {
    loading,
    handleDownload,
  };
};

export default useDownloadInstructions;
